<template>
    <div class="gh-section how-it-work">
        <div class="container">
            <h2 class="gh-section__heading gh-section__heading-large text-left">How it works</h2>
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <ul class="steps">
                        <li v-for="step in steps" :key="step.heading" :class="stepClasses(step)" @click="changeImage(step)">
                            <div class="step-badge">
                                <span class="tag is-primary">{{ step.order }}</span>
                            </div>
                            <div class="step-details">
                                <h3 class="title">{{ step.heading }}</h3>
                                <p>{{ step.description }}</p>
                            </div>
                        </li>
                    </ul>
                    <div class="action">
                        <router-link class="gh-button-redesign gh-button-redesign--primary gh-button-home-redesign" to="/join">Join Now</router-link>
                    </div>
                </div>
                <div class="col-md-6 step-image">
                    <transition enterActiveClass="animated fadeIn" leaveActiveClass="animated fadeOut" mode="out-in">
                        <img id="js-step-image" :src="activeStepImage" v-if="showStepImage" alt="step image" width="543" height="398" loading="lazy">
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                showStepImage: true,
                activeStep: 1
            }
        },

        computed: {
            LaraVue() {
                return LaraVue
            },

            steps() {
                return [
                    {
                        order: 1,
                        heading: 'Become an MHA member',
                        description: 'It only takes a minute, and you’ll get instant access to resources.',
                    },
                    {
                        order: 2,
                        heading: `Learn from over ${this.LaraVue.figure.totalHours} hours of text and video-based programs`,
                        description: 'Created by experts – available on-demand, online, 24/7.'
                    },
                    {
                        order: 3,
                        heading: 'Complete assessments, download certificates, and manage all your CPD records online',
                        description: 'Our custom built online platform was designed to optimise your learning experience.',
                    },
                ]
            },

            activeStepImage() {
              return `https://d26heqcxf097pb.cloudfront.net/webp/images/app/how-it-works-images-${this.activeStep}.webp`
            }
        },

        methods: {
            stepClasses(step) {
                return {
                    'js-step step': true,
                    'is-active': step.order === this.activeStep
                };
            },

            changeImage(step) {
                if (step.order === this.activeStep) return false;

                this.showStepImage = false;
                this.activeStep = step.order;

                setTimeout(() => {
                    this.showStepImage = true;
                }, 300);

            }
        }
    }
</script>
